import { uniGetTargetElements } from './get-target-elements';
export function uniAddProp(el, prop, value, all, selector) {
  Array.from(uniGetTargetElements(el, all, selector))
    .forEach((element) => {
    if (element) {
      element[prop] = value;
    }
  });
}
